import React, { useEffect, useState } from 'react';

import { NavCountBadge } from './NavCountBadge';
import { useSelector } from 'react-redux';
// mui
// helpers
import _ from 'lodash';
// actions
import { unReadPolicy } from '../../../policies/PolicyService';
// utils
import { PubSub } from '../../../utils/eventUtils';

export const PoliciesBadge = ({ children }: any) => {
  const teamDetails = useSelector(({ uiSettings }) => uiSettings.team);
  const [unread, setUnread] = useState(0);

  // effects
  useEffect(() => {
    function fetch() {
      unReadPolicy({ teamIds: teamDetails.id }).then(({ data }: any) => {
        const count = _.get(
          data,
          'aggregations.Read.Read.buckets[0].doc_count',
          0
        );
        setUnread(count);
      });
    }

    const subscription = PubSub.subscribe('policy:read', fetch);

    fetch();

    return () => {
      subscription.remove();
    };
    // eslint-disable-next-line
  }, [teamDetails]);

  return <NavCountBadge count={unread}>{children}</NavCountBadge>;
};
